import { ContactForm } from "../components/ContactForm";
import { Container, Typography, Link } from "@mui/material";

export const Contact = () => {
  return (
    <Container
      sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}
    >
      <Typography variant="h2">Contact</Typography>
      <Typography variant="caption" sx={{ mt: 3 }}>
        Please reach out to me using this contact form or for a faster response
        my email:{" "}
        <Link href="mailto:leanne_gallag@live.co.uk" sx={{textDecoration:"none"}}>
          Leanne_Gallag@live.co.uk
        </Link>
      </Typography>
      <ContactForm />
    </Container>
  );
};
